<dx-file-manager *ngIf="this.__oFileSystemConfiguration"
                 id="fileManager"
                 [fileSystemProvider]="__oFileSystemProvider"
                 [customizeThumbnail]="customizeIcon"
                 (onCurrentDirectoryChanged)="onDirectoryChanged($event)">
  <ng-container *ngIf="__bMenuVisible">
    <dxo-permissions [create]="this.__oFileSystemConfiguration?.bAllowCreate"
                     [copy]="this.__oFileSystemConfiguration?.bAllowCopy"
                     [move]="this.__oFileSystemConfiguration?.bAllowMove"
                     [delete]="this.__oFileSystemConfiguration?.bAllowDelete"
                     [rename]="this.__oFileSystemConfiguration?.bAllowRename"
                     [upload]="this.__oFileSystemConfiguration?.bAllowUpload"
                     [download]="this.__oFileSystemConfiguration?.bAllowDownload">
    </dxo-permissions>
  </ng-container>
  <ng-container *ngIf="!__bMenuVisible">
    <dxo-permissions [create]="this.__oFileSystemConfiguration?.bAllowCreate">
    </dxo-permissions>
  </ng-container>
  <dxo-upload [chunkSize]="this.__oFileSystemConfiguration.lMaxFileSize" [maxFileSize]="this.__oFileSystemConfiguration.lMaxFileSize"></dxo-upload>
  <dxo-item-view [showParentFolder]="false">
    <dxo-details>
      <dxi-column dataField="thumbnail"></dxi-column>
      <dxi-column dataField="name"></dxi-column>
      <dxi-column dataField="dateModified" width="200"></dxi-column>
    </dxo-details>
  </dxo-item-view>
  <dxo-toolbar>
    <dxi-item name="upload" text="Upload File(s)" icon="" cssClass="toolbar-button"></dxi-item>
    <dxi-item name="create" text="Create Directory" icon="" cssClass="toolbar-button"></dxi-item>
    <dxi-file-selection-item name="download" text="Download File(s)" icon="" cssClass="toolbar-button"></dxi-file-selection-item>
    <dxi-file-selection-item name="move" text="Move" icon="" cssClass="toolbar-button"></dxi-file-selection-item>
    <dxi-file-selection-item name="copy" text="Copy" icon="" cssClass="toolbar-button"></dxi-file-selection-item>
    <dxi-file-selection-item name="rename" text="Rename" icon="" cssClass="toolbar-button"></dxi-file-selection-item>
    <dxi-file-selection-item name="delete" text="Delete" icon="" cssClass="toolbar-button"></dxi-file-selection-item>
    <dxi-file-selection-item name="refresh" text="Refresh" icon="" cssClass="toolbar-button"></dxi-file-selection-item>
    <dxi-file-selection-item name="clearSelection" text="Clear Selection" icon="" cssClass="toolbar-button"></dxi-file-selection-item>
  </dxo-toolbar>

  <dxo-notifications [showPanel]="false"
                     [showPopup]="true">
  </dxo-notifications>

  <dxo-context-menu>
    <dxi-item name="move" icon="" text="Move"></dxi-item>
    <dxi-item name="copy" icon="" text="Copy"></dxi-item>
    <dxi-item name="rename" icon=""></dxi-item>
    <dxi-item name="delete" icon=""></dxi-item>
    <dxi-item name="download" icon=""></dxi-item>
  </dxo-context-menu>
</dx-file-manager>
